<div class="mat-dialog-container">
	<h2 mat-dialog-title>{{ "ORDER_BASKET.FIND_MATERIAL_DIALOG.TITLE" | translate }}</h2>
	<div mat-dialog-content>
		<cass-indeterminate-circular-progress-indicator *ngIf="isLoading"></cass-indeterminate-circular-progress-indicator>
		<div class="no-data" *ngIf="!isLoading && !isDataReady">{{ "ORDER_BASKET.FIND_MATERIAL_DIALOG.NO_DATA_MSG" | translate }}</div>
		<div class="table-container" *ngIf="!isLoading && isDataReady">
			<table #advertiserMaterialTable
				   mat-table
				   matSort
				   multiTemplateDataRows
				   [dataSource]="advertiserMaterialTableDataSource">
				<ng-container matColumnDef="select">
					<th mat-header-cell *matHeaderCellDef>{{ "ORDER_BASKET.FIND_MATERIAL_DIALOG.TABLE_COLUMN.SELECT" | translate }}</th>
					<td mat-cell *matCellDef="let row">
						<mat-radio-button color="primary" (click)="$event.stopPropagation()"
										  (change)="selectItem(row)"
										  [checked]="selection.isSelected(row)"></mat-radio-button>
					</td>
				</ng-container>
				<ng-container *ngFor="let column of advertiserMaterialTableColumnDefs" [matColumnDef]="column.key">
					<th mat-header-cell *matHeaderCellDef mat-sort-header class="{{ column.className }}">{{ column.heading | translate }}</th>
					<ng-container *ngIf="column.key === 'thumbnail'; else noThumbnail">
						<td mat-cell
							*matCellDef="let row"
							[title]="(column.displayValue ? column.displayValue(row) : row[column.key] || '')"
							class="{{ column.className }}">
							<img [src]="(column.displayValue ? column.displayValue(row) : row[column.key]) | authImage | async"
								 [alt]="column.key">
						</td>
					</ng-container>
					<ng-template #noThumbnail>
						<td mat-cell
							*matCellDef="let row"
							[title]="column.key === 'productId' ? '' : (column.displayValue ? column.displayValue(row) : row[column.key] || '')"
							class="{{ column.className }}">
							{{ column.displayValue ? column.displayValue(row) : row[column.key] }}
						</td>
					</ng-template>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="advertiserMaterialTableDisplayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: advertiserMaterialTableDisplayedColumns"></tr>
			</table>
		</div>
	</div>
	<div mat-dialog-actions class="button-container">
		<button mat-flat-button
				(click)="closeDialog()">
			{{'ACTION_BUTTON_LABELS.CLOSE' | translate}}
		</button>
		<button mat-flat-button color="primary" [disabled]="!selectedItem"
				(click)="save()">
			{{'ACTION_BUTTON_LABELS.SAVE' | translate}}
		</button>
		<button mat-flat-button color="primary" [disabled]="!selectedItem"
				(click)="repeatWithChanges()"
				*ngIf="isRepeatWithChangesEnabled">
			{{'ACTION_BUTTON_LABELS.REPEAT_WITH_CHANGES' | translate}}
		</button>
	</div>
</div>
